import {
	WeaTools
} from 'ecCom'

export const getAuth = (params) => {
	return WeaTools.callApi('/api/hrm/applyinfo/getHasRight', 'GET', params);
}

export const getButtonsMenu = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getRightMenu', 'GET', params);
}

export const getRadioGroupDatas = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getSearchCondition', 'GET', params);
}

export const getBarChartsDatas = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getRpResult', 'GET', params);
}

export const getTabsDatas = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getRpResult2', 'GET', params);
}

export const getSearchCondition = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getDetailSearchCondition', 'GET', params);
}

export const getApplyInfoRpList = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getMoreJobtitleList', 'GET', params);
}

export const getDetailSearchList = (params) => {
	return WeaTools.callApi('/api/hrm/applyinforp/getDetailSearchList', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/applicant.js